module.exports = __webpack_public_path__ + "static/media/view.4d668257.svg";